import React, { useEffect, useState, useRef, useMemo } from 'react';
import {
  FormControl,
  MenuItem,
  Select,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import { AccountBalanceWallet, AddCircle, Close } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/CustomButtons/Button';
import GridItem from 'components/Grid/GridItem';
import { wsGetAll } from 'services/WService';
import Table from '@material-ui/core/Table';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment/moment';

const useStyles = makeStyles({
  table: {
    minWidth: 1100,
  },
  grid: {
    fontWeight: 'bold',
    textAlign: 'end',
  },
  div: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignContent: 'space-around',
    flexWrap: 'nowrap',
    alignItems: 'baseline',
  },
  totalPay: {
    marginRight: '10px',
    fontSize: '17px',
  },
  input: {
    fontWeight: 'bold',
  },
});

const columns = [
  { field: 'DueDate', type: 'date', width: 200, header: 'Fecha Vto.' },
  { field: 'CheckSum', type: 'number', width: 200, header: 'Importe' },
  { field: 'AbsEntry', type: 'text', width: 200, custom: true, header: 'Cuenta de mayor' },
  { field: 'CheckNum', type: 'number', width: 200, header: '# Cheque' },
];

const defaultCheck = {
  DueDate: moment().add(1, 'days').format('YYYY-MM-DD'),
  CheckSum: 0,
  BankCode: '02',
  CheckNum: '',
};

function TabCheck(props) {
  const classes = useStyles();
  const formRef = useRef(null);
  const { totalAmount, payWithDocuments } = props;
  const { payment, setPayment } = props;
  const { checks, setChecks } = props;
  const { paymentMethod, setPaymentMethod } = props;
  const [checkAccounts, setCheckAccounts] = useState([]);
  const isDisabled = useMemo(() => paymentMethod === 'CK', [paymentMethod]);

  async function listAccounts() {
    let res = await wsGetAll('pymt/transfer-accounts');
    if (res.success) {
      setCheckAccounts(res.data);
    }
  }

  function addRow() {
    if (isDisabled) return;

    let data = {
      id: uuidv4(),
      ...defaultCheck,
    };
    setChecks([...checks, data]);
  }

  const handleChangeRow = (e, id) => {
    if (isDisabled) return;
    let value = e.target.value;
    let fieldName = e.target.name;

    let objIndex = checks.findIndex((obj) => obj.id == id);
    let newChecks = [...checks];
    newChecks[objIndex][fieldName] = value;

    let CheckSum = newChecks.reduce(
      (prev, currentCheck) => prev + parseFloat(currentCheck.CheckSum),
      0,
    );

    if (!payWithDocuments) {
      setPayment((payment) => ({ ...payment, CheckSum }));
      return;
    }

    setChecks(newChecks);
    setPayment((payment) => ({ ...payment, CheckSum }));
  };

  function deleteRow(id) {
    if (isDisabled) return;
    checks.splice(
      checks.findIndex((x) => x.id == id),
      1,
    );
    setChecks([...checks]);
  }

  function getDataForm(form) {
    let dataForm = {};
    for (let input of form.current.querySelectorAll('[name]')) {
      dataForm[input.name] = input.value;
    }
    return dataForm;
  }

  // function groupData() {
  //   let data = { ...getDataForm(formRef), checks: checks };
  //   if (payment > 0) {
  //     if (totalChecks.toFixed(2) != payment.toFixed(2)) {
  //       showNotify('La suma de los cheches no coincide con el monto a pagar', 'info');
  //     } else {
  //       handleMethod(type, true);
  //       processPayment(type, data);
  //     }
  //   } else {
  //     if (parseFloat(totalChecks.toFixed(2)) != parseFloat(amountPay.toFixed(2))) {
  //       /* console.log(parseFloat(totalChecks.toFixed(2)), parseFloat(amountPay.toFixed(2))); */
  //       showNotify('La suma de los cheches no coincide con la suma de los documentos', 'info');
  //     } else {
  //       handleMethod(type, true);
  //       processPayment(type, data);
  //     }
  //   }
  // }

  function handleSubmit(e) {
    e.preventDefault();
    // groupData();
  }

  useEffect(() => {
    // listBanks();
    listAccounts();
    if (checks.length === 0) {
      setChecks([{ id: uuidv4(), ...defaultCheck }]);
    }

    return () => {
      setChecks([]);
      setPayment((payment) => ({ ...payment, CheckSum: undefined }));
    };
  }, []);

  return (
    <GridContainer style={{ width: '100%' }}>
      <GridItem xs={12} style={{ marginBottom: '15px' }}>
        <form onSubmit={handleSubmit} ref={formRef}>
          <GridContainer>
            <GridItem xs={12} md={3} lg={3}>
              <TextField
                name="CheckSum"
                label="Total a pagar"
                type="number"
                fullWidth
                value={payment.CheckSum || 0}
                margin="normal"
                inputProps={{
                  min: 0,
                  step: 0.0001,
                }}
                required
                disabled={isDisabled}
              />
            </GridItem>
            <GridItem xs={12} md={3} lg={6} style={{ display: 'flex', alignItems: 'flex-end' }}>
              <Button
                color={isDisabled ? 'danger' : 'primary'}
                size="sm"
                onClick={(e) => {
                  if (isDisabled) {
                    setPaymentMethod(null);
                    return;
                  }
                  setPaymentMethod('CK');
                }}
                // form="formTR"
                // type="submit"
              >
                {isDisabled ? <Close /> : <AccountBalanceWallet />}
                {isDisabled ? 'Quitar' : 'Agregar'}
              </Button>
            </GridItem>
          </GridContainer>
        </form>
      </GridItem>
      <GridItem xs={12}>
        <TableContainer>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell style={{ paddingBottom: '5px', paddingTop: '5px' }} width={100}>
                  <AddCircle
                    style={{
                      color: isDisabled ? '#ACC8AF' : '#4caf50',
                      cursor: isDisabled ? 'inherit' : 'pointer',
                    }}
                    fontSize="large"
                    onClick={() => {
                      addRow();
                    }}
                  />
                </TableCell>

                {columns.map((item, i) => {
                  return (
                    <TableCell key={i} width={item.width}>
                      {item.header}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {checks.map((objCheck, i) => {
                return (
                  <TableRow key={i}>
                    <TableCell>
                      {i + 1}
                      <Button
                        justIcon
                        round
                        simple
                        color="danger"
                        onClick={() => deleteRow(objCheck.id)}
                        disabled={isDisabled}
                      >
                        <Close />
                      </Button>
                    </TableCell>
                    {columns.map((itemColum, i) => {
                      return (
                        <TableCell key={i} width={1}>
                          {itemColum.custom ? (
                            <FormControl fullWidth size="small" disabled={isDisabled}>
                              <Select
                                inputProps={{
                                  name: 'AbsEntry',
                                  onChange: (e) => {
                                    handleChangeRow(e, objCheck.id);
                                  },
                                }}
                              >
                                {checkAccounts.map((item, i) => {
                                  return (
                                    <MenuItem value={item.AbsEntry} key={i}>
                                      {`${!!item.City ? item.City + ' - ' : ''}${item.BankName} - ${
                                        item.Branch
                                      }`}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          ) : (
                            <TextField
                              // key={checks + amountPay}
                              name={itemColum.field}
                              defaultValue={
                                itemColum.type === 'date'
                                  ? objCheck[itemColum.field] || moment().format('YYYY-MM-DD')
                                  : objCheck[itemColum.field]
                              }
                              inputProps={{
                                min:
                                  itemColum.type === 'date'
                                    ? moment().add(1, 'days').format('YYYY-MM-DD')
                                    : 0,
                                step: 0.0001,
                              }}
                              size="small"
                              type={itemColum.type}
                              fullWidth
                              onChange={(e) => {
                                handleChangeRow(e, objCheck.id);
                              }}
                              onKeyPress={(e) => {
                                var key = window.event ? e.which : e.keyCode;
                                if (key === 101) {
                                  return e.preventDefault();
                                }
                              }}
                              disabled={isDisabled}
                            />
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </GridItem>
    </GridContainer>
  );
}

export default TabCheck;
